import {FaqsInfoValueObject} from './FaqsInfoValueObject.js'
import {MakeModelValueObject} from './MakeModelValueObject.js'
import {SeoDataValueObject} from './SeoDataValueObject.js'
import {StructuredDataValueObject} from './StructuredDataValueObject.js'
import {TagcloudListValueObject} from './TagcloudListValueObject.js'
import TagcloudSeoValueObject from './TagcloudSeoValueObject.js'
import TagSeoValueObject from './TagSeoValueObject.js'

export default class SeoValueObjectsFactory {
  static faqsInfoValueObject = ({faqs, seoFaqs, title}) => new FaqsInfoValueObject({faqs, seoFaqs, title})

  static seoDataValueObject = ({h1, staticFallbackH1, head: {title, meta, link, scripts}} = {}) =>
    new SeoDataValueObject({
      h1,
      ...(staticFallbackH1 !== undefined && {staticFallbackH1}),
      head: {title, meta, link, scripts}
    })

  static structuredDataValueObject = structuredData => new StructuredDataValueObject(structuredData)

  static makeModelValueObject = ({make, model}) => new MakeModelValueObject({make, model})

  static tagcloudSeoValueObject = ({config}) => {
    const tagSeoValueObjectFactory = SeoValueObjectsFactory.tagSeoValueObject

    return ({attributes, title, tags}) =>
      new TagcloudSeoValueObject({
        attributes,
        title,
        tags: tags.map(({label, link, title}) => tagSeoValueObjectFactory({label, link, title}))
      })
  }

  static tagSeoValueObject = ({label, link, title}) => new TagSeoValueObject({label, link, title})

  static tagcloudListValueObject = ({tagclouds}) => new TagcloudListValueObject({tagclouds})
}
